/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var PaginatedChatMessagesPageInfoDto;
(function (PaginatedChatMessagesPageInfoDto) {
    let direction;
    (function (direction) {
        direction["BEFORE"] = "before";
        direction["AFTER"] = "after";
    })(direction = PaginatedChatMessagesPageInfoDto.direction || (PaginatedChatMessagesPageInfoDto.direction = {}));
})(PaginatedChatMessagesPageInfoDto || (PaginatedChatMessagesPageInfoDto = {}));
